import { Theme, darken } from '@mui/material/styles'

import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()((theme: Theme) => ({
  autoCompleteWrapper: {
    display: 'flex',
    gap: theme.spacing(4),
    flexDirection: 'column',
  },
}))
